<template>
  <v-app class="root">
    <v-main>
      <template v-if="initialLoadingStatus === 1">
        <div class="root-header" >
          <booking-steps />
        </div>

        <div class="root-body">
          <accommodation-variants
            v-if="step === 1"
          />

          <booking
            v-else-if="step >= 2 && step <= 5"
          />
        </div>
      </template>

      <template v-else-if="initialLoadingStatus === -1">
        <div class="app-loading-fail">Не удалось загрузить данные для работы приложения</div>
      </template>
    </v-main>

    <v-dialog
      v-model="showBookingError"
      max-width="998"
      style="z-index:1002"
    >
      <ui-dialog
        title="Ошибка при бронировании!"
        picture="img/misc/cross.svg"
        @close="showBookingError = false"
      >
        <div style="text-align: center;">
          <div class="mb-2">
            Произошла ошибка при бронировании, обратитесь к администратору.
          </div>
        </div>
      </ui-dialog>
    </v-dialog>

    <v-dialog
      v-model="showBookingSuccess"
      max-width="998"
      style="z-index:1002"
    >
      <ui-dialog
        title="Бронирование оформлено!"
        picture="img/misc/success-pic.svg"
        @close="showBookingSuccess = false"
      >
        <div style="text-align: center;">
          <div class="mb-2">
            На Вашу почту выслана вся подробная информация о заезде.
          </div>
          <div v-if="successBooking.extra.hasExtra">
            <a class="booking-result_link mb-2"
               v-if="successBooking.extra.payment.status === 'pending'"
               :href="successBooking.extra.payment.confirmUrl">
              Оплатить дополнительный счет
            </a>
            <div v-if="successBooking.extra.payment.status === 'succeeded'">
              Дополнительный счет оплачен
            </div>
            <div v-if="successBooking.extra.payment.status === 'canceled'">
              Произошла ошибка при оплате дополнительного счета
            </div>
            <div v-if="successBooking.extra.payment.status == null">
              Произошла ошибка при получении дополнительного счета
            </div>
          </div>
          <a class="booking-result_link mb-2"
             v-if="successBooking.isPresent"
             @click.prevent="downloadPdfClick"
             download>
            Скачать pdf файл путевки
          </a>
        </div>
      </ui-dialog>
    </v-dialog>

    <v-overlay
      v-if="isLoading"
      z-index="9999"
    >
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import BookingSteps from '@/components/BookingSteps.vue'
import AccommodationVariants from '@/components/AccommodationVariants.vue'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Booking from './components/Booking.vue';

export default {
  name: 'App',

  components: {
    BookingSteps,
    AccommodationVariants,
    Booking,
  },

  data: () => ({
    showBookingSuccess: false,
    successBooking: {
      extra: {
        hasExtra: false,
        payment: {
          status: null,
          confirmUrl: '',
        },
      },
      isPresent: false,
      dealId: null,
    },

    showBookingError: false,
  }),

  computed: {
    ...mapState({
      step: state => state.bookingStep,
      isLoading: state => state.isLoading,
      initialLoadingStatus: state => state.dictionaries.initialLoadingStatus,
    }),
  },

  methods: {
    ...mapActions({
      fetchDictionaries: 'dictionaries/fetchDictionaries',
    }),

    scrollToTheTop() {
      document.querySelector(`.root-header`).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },

    async downloadPdfClick() {
      try {
        const dealId = this.successBooking.dealId || false,
          pathDownload =  `/booking/deal/${dealId}/getPresentPdfFilePath/`;

        window.open(pathDownload);
      }
      catch (e) {
        console.error(e);
      }
    },
  },

  watch: {
    step() {
      this.scrollToTheTop()
    },

    showBookingSuccess(newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        document.location.href = '/'
      }
    },
  },

  async mounted() {
    // парсинг get-параметров, их очистка
    const queryString = window.location.search,
     urlParams = new URLSearchParams(queryString)

    try {
      if (urlParams.has('deal-id')) {
        const payload = {
          dealId: urlParams.get('deal-id')
        }
        const response = await this.$http.post(`/payment/info/`, payload),
          data = response?.data?.data ?? {},
          deal = data.deal ?? {},
          payments = data.payments ?? []

        if (payments.length === 0) return

        // 1. Проверить - оплачен ли главный счет
        let mainPayment = payments.find((payment) => {
          let orderNumber = payment.orderNumber.split('|')[0] ?? ''
          return !orderNumber.includes('/3')
        })
        switch (mainPayment.status) {
          case 'pending':
          case 'waiting_for_capture':
            return;
          case 'canceled':
            // произошла ошибка - вывести окно
            this.showBookingError = true
            return
        }

        let extraPayment = payments.find((payment) => {
          let orderNumber = payment.orderNumber.split('|')[0] ?? ''
          return orderNumber.includes('/3')
        })

        // 2. Если главный счет оплачен - вывести модалку
        this.showBookingSuccess = true
        this.successBooking = {
          extra: {
            hasExtra: extraPayment != null,
            payment: extraPayment || {},
          },
          isPresent: deal.ufCrmDealBookingType.code === 'present',
          dealId: deal.id,
        }
      }
    }
    catch (e) {
      console.error(e)
    }
  },

  beforeMount() {
    this.fetchDictionaries()
  },
};
</script>

<style lang="sass">
.v-application
  ul li:before
    display: none

.v-main__wrap
  display: flex
  flex-direction: column

.root
  padding: px-em(10) px-em(20)

.root-header
  width: 100%
  // max-width: px-em(1100)
  margin: 0 auto px-em(20)

.root-body
  flex-grow: 1

.app-loading-fail
  width: 100%
  height: 100%
  display: flex
  align-items: center
  justify-content: center
</style>
